import { AsyncPipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core';
import { Observable, Subscription, combineLatest } from 'rxjs';
import { switchMap, take, tap } from 'rxjs/operators';
import { ShimanoCountryService } from 'src/app/service/country/shimano-country.service';
import { CustomTranslationService } from 'src/app/service/language/custom-translation.service';
import { ShimanoLanguageService } from 'src/app/service/language/shimano-language.service';
import { StandardModalService } from 'src/app/service/modal/standard-modal.service';
import {
  MyaccountPersonalInfoService,
  RemoveAddressPayload,
} from 'src/app/service/myaccount/myaccount-personal-info.service';

@Component({
  selector: 'app-myacc-address-modal',
  templateUrl: './myacc-address-modal.component.html',
  styleUrls: ['./myacc-address-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [AsyncPipe],
  standalone: false,
})
export class MyaccAddressModalComponent implements OnInit {
  addressId: string;

  customTranslationSubscription: Subscription;
  isCustomTranslationsEnabled: boolean;
  activeCountry = this.pipeAsync.transform(this.activeCountry$);
  activeLanguage = this.pipeAsync.transform(this.activeLanguage$);

  constructor(
    protected modalService: StandardModalService,
    private personalService: MyaccountPersonalInfoService,
    private messageService: GlobalMessageService,
    private customTranslationService: CustomTranslationService,
    private pipeAsync: AsyncPipe,
    private countryService: ShimanoCountryService,
    private languageService: ShimanoLanguageService,
    private cdr: ChangeDetectorRef
  ) {
    this.modalService
      .getModalData()
      .pipe(take(1))
      .subscribe((res) => {
        this.addressId = res.addressId;
      });
  }

  ngOnInit() {
    this.customTranslationSubscription = combineLatest([this.activeCountry$, this.activeLanguage$])
      .pipe(
        switchMap(([activeCountry, activeLanguage]) =>
          this.customTranslationService.isCustomTranslationsEnabled$(activeCountry, activeLanguage, [
            'personalInfo.deleteDeliveryPending',
          ])
        ),
        tap((isCustomTranslationsEnabled) => {
          this.isCustomTranslationsEnabled = isCustomTranslationsEnabled;
        })
      )
      .subscribe();
  }

  get activeCountry$(): Observable<string> {
    return this.countryService.getActive();
  }

  get activeLanguage$(): Observable<string> {
    return this.languageService.getActive();
  }

  setCustomTranslation(translationKey: string, activeCountry: string, activeLanguage: string): string {
    return this.isCustomTranslationsEnabled
      ? translationKey + '_' + [activeCountry, activeLanguage].join('-')
      : translationKey;
  }

  requestDelete() {
    const payload: RemoveAddressPayload = {
      addressId: this.addressId,
    };
    this.personalService.removeAddress(payload).subscribe((data) => {
      this.closeModal({ isPending: true });
      this.messageService.add(
        {
          key: this.setCustomTranslation('personalInfo.deleteDeliveryPending', this.activeCountry, this.activeLanguage),
        },
        GlobalMessageType.MSG_TYPE_CONFIRMATION
      );
    });
  }

  closeModal(info?: any) {
    this.modalService.closeDialog(info);
  }

  private showGlobalMessage(text: string, messageType: GlobalMessageType) {
    this.messageService.add({ key: text }, messageType);
    const element: HTMLElement = document.getElementsByClassName('BottomHeaderSlot')[0] as HTMLElement;
    element.scrollIntoView();
  }
}
